import ajax from '@/services';

export const getUser = params =>
  ajax.request({
    url: '/df/checkout',
    method: 'get',
    params
  });

export const logout = params =>
  ajax.request({
    url: '/df/logout',
    method: 'get',
    params
  });

export const getPermissions = async () => ajax.request({
  url: '/df/perminsions',
  method: 'get',
})

export const getConfigurableApi = async () => ajax.request({
  url: '/df/permission-options',
  method: 'get',
})




